import Vue from 'vue'
import Vuex, { Store } from 'vuex'

Vue.use(Vuex)

import input from './modules/input'
import notification from './modules/notification'
import comm from './modules/comm'
import user from './modules/user'
import getters from './getters'


export default new Vuex.Store({
    modules: {
        input,
        notification,
        comm,
        user
    },
    getters
})
